export const FETCH_POSTS_REQUEST = 'FETCH_POSTS_REQUEST';
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';

export const BANNED_OR_UNBANNED_POST_REQUEST = 'BANNED_OR_UNBANNED_POST_REQUEST';
export const BANNED_OR_UNBANNED_POST_SUCCESS = 'BANNED_OR_UNBANNED_POST_SUCCESS';
export const BANNED_OR_UNBANNED_POST_FAILURE = 'BANNED_OR_UNBANNED_POST_FAILURE';
